export default __webpack_public_path__ + "static/media/IntroBonus.b6cf94f8.svg";